import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';
import { usePrivacy } from '../../context/PrivacyContext';
import '../../styles/privacy.css';

const CookieConsentBanner = () => {
    const { language } = useLanguage();
    const { t } = useTranslation(language);
    const {
        isCookieBannerVisible,
        acceptAllCookies,
        rejectAllCookies,
        openPrivacyModal
    } = usePrivacy();

    if (!isCookieBannerVisible) {
        return null;
    }

    return (
        <div className="cookie-banner" role="dialog" aria-live="polite">
            <div className="cookie-banner__content">
                <h4>{t('cookieBanner.title')}</h4>
                <p>{t('cookieBanner.description')}</p>
            </div>

            <div className="cookie-banner__actions">
                <button type="button" className="ghost-button" onClick={openPrivacyModal}>
                    {t('cookieBanner.learnMore')}
                </button>
                <button type="button" className="secondary-button" onClick={rejectAllCookies}>
                    {t('cookieBanner.reject')}
                </button>
                <button type="button" className="primary-button" onClick={acceptAllCookies}>
                    {t('cookieBanner.accept')}
                </button>
            </div>
        </div>
    );
};

export default CookieConsentBanner;

